<template>
    <layout-portal>
        <div class="container">
			<div class="row">
				<div class="col-md-12 text-center mt-3">
					<h1>Oops!</h1>
					<h2>403 Sem acesso </h2>
					<p>Desculpe, você não tem permissão para aceder ao recurso!</p>
					<div class="error-actions">
						<button @click="handleBack" type="button" class="btn btn-dark">Voltar</button>
					</div>
				</div>
			</div>
		</div>
    </layout-portal>
</template>

<script>
    import mixin from '../mixin'

    export default
    {
        mixins: [mixin],
    }
</script>